import React, { } from 'react'
import { useSelector } from 'react-redux'
import ProjectsPageMUI from '../components/projects/ProjectsPageMUI';
import { Navigate } from 'react-router-dom'

const ProjectsPage = () => {
    const userLogin = useSelector((state) => state.userLogin)
    return (

        <>
            {userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0?
                <ProjectsPageMUI /> :
                // <ProjectPageCRUD /> :
                <Navigate to="/login" replace={true} />}


        </>
    )
}
export default ProjectsPage
